import { motion } from "framer-motion";
import { DIFFERENCE, MOTTO } from "../../lib/content";
import { Reveal, EASE } from "../Reveal";

export const Manifesto = () => (
  <section data-testid="manifesto" className="relative bg-dst-ink py-24 lg:py-36 overflow-hidden grain">
    <div className="container-dst relative z-10">
      <Reveal className="max-w-3xl mb-20">
        <span className="eyebrow text-dst-red">The DST Difference</span>
        <h2 className="mt-4 font-oswald font-700 uppercase tracking-tighter leading-[0.9] text-5xl lg:text-7xl">
          We Develop The Whole<br /><span className="text-dst-red">Competitor</span>
        </h2>
        <p className="mt-6 text-white/60 text-lg leading-relaxed">
          Physical talent is only half the equation. At DST we align the mind and body — building athletes who compete with discipline, confidence, and purpose.
        </p>
      </Reveal>

      <div className="space-y-0">
        {DIFFERENCE.map((d, i) => (
          <motion.div
            key={d.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, ease: EASE }}
            data-testid={`difference-${i}`}
            className="group relative grid grid-cols-1 lg:grid-cols-[160px_1fr_1.2fr] gap-4 lg:gap-10 items-baseline py-8 border-t border-white/10 hover:border-dst-red/50 transition-colors"
          >
            <div className="font-oswald font-700 text-6xl lg:text-7xl text-white/10 group-hover:text-dst-red transition-colors duration-500 leading-none">
              {d.n}
            </div>
            <h3 className="font-oswald uppercase tracking-tight text-3xl lg:text-4xl group-hover:translate-x-2 transition-transform duration-500">
              {d.title}
            </h3>
            <p className="text-white/55 leading-relaxed lg:text-lg">{d.text}</p>
          </motion.div>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-20 border-l-2 border-dst-red pl-8 max-w-4xl">
        <p className="font-oswald text-2xl lg:text-3xl uppercase tracking-tight leading-snug text-white/90">
          "{MOTTO}"
        </p>
      </Reveal>
    </div>
  </section>
);
